import { contentfulImageLoader } from "@utils/imageLoader";
import { transparentPixel } from "@utils/string";
import { FC } from "react";

import { Media } from "@/types";

interface CardImageSimpleProps {
  image: Media;
  aspectRatio: "3:4" | "4:3";
}

const CardImageSimple: FC<CardImageSimpleProps> = ({ image, aspectRatio }) => {
  const is34 = aspectRatio === "3:4";
  const src = image.url || transparentPixel;
  const widths = is34 ? [343, 473, 686, 946] : [457, 609, 840, 1218];
  return (
    <div className={`h-CardGallery md:h-CardGalleryDesktop ${is34 ? "aspect-3-4" : "aspect-4-3"}`}>
      <img
        className="object-cover w-full h-full rounded-md"
        src={contentfulImageLoader({ src, width: widths[0], quality: 80 })}
        srcSet={widths.map((w) => `${contentfulImageLoader({ src, width: w, quality: 80 })} ${w}w`).join(", ")}
        sizes={is34 ? "(min-width: 1024px) 473px, 343px" : "(min-width: 1024px) 840px, 609px"}
        alt={image.description || image.title}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
};
export default CardImageSimple;
